import CopyableText from "src/components/CopyableText";
import { Params } from "src/features/common/types/GridRenderCellParams";
import { GetListRes } from "../types/GetListRes";

const useCopyableCell = () => {
  const renderCopyableCell =
    (direction: "spenderAddress" | "invokerAddress") =>
    (params: Params<GetListRes>) => {
      const getValue = () => {
        switch (direction) {
          case "spenderAddress":
            return params.row.rawData.spender_address;
          case "invokerAddress":
            return params.row.rawData.invoker_address;
          default:
            return "";
        }
      };
      return <CopyableText text={getValue()} handleOverflow />;
    };
  return {
    renderCopyableCell,
  };
};
export default useCopyableCell;
